import React, { useState } from 'react'
import { Form, Row, Col } from 'react-bootstrap'
import { connect } from 'formik'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import EmailOptIn from '../EmailOptInModal/EmailOptInModal.js'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

import classNames from 'classnames'
import styles from './SamsungAccountDetailsField.module.scss'

const SamsungAccountDetailsFields = ({
  formik,
  showOtherDetails = false,
  canEditFirstName,
  canEditMiddleName,
  canEditLastName,
  alignCenter = true,
  columnSize = 5,
  adSSoSettings,
  translationDisabled = false,
  isB2bAccount = false
}) => {
  const { t } = useTranslation('common')
  const [show, setShow] = useState(false)

  return (
    <>
      <Row>
        <Form.Group
          as={Col}
          md={columnSize}
          className={alignCenter ? 'mx-auto' : ''}
          controlId="validationFormik01"
        >
          <Form.Label>{translationDisabled ? 'First name' : t('First_name')}</Form.Label>
          <Form.Control
            type="text"
            name="firstName"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.firstName}
            maxLength={!isB2bAccount && 30}
            readOnly={!canEditFirstName}
          />
          <Form.Control.Feedback type="invalid">{formik.errors.firstName}</Form.Control.Feedback>
        </Form.Group>
      </Row>
      {isB2bAccount && (
        <Row>
          <Form.Group
            as={Col}
            md={columnSize}
            className={alignCenter ? 'mx-auto' : ''}
            controlId="validationFormik01"
          >
            <Form.Label>Middle name (optional)</Form.Label>
            <Form.Control
              type="text"
              name="middleName"
              value={formik.values.middleName}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.middleName}
              maxLength={!isB2bAccount && 30}
              readOnly={!canEditMiddleName}
            />
            <Form.Control.Feedback type="invalid">{formik.errors.middleName}</Form.Control.Feedback>
          </Form.Group>
        </Row>
      )}
      <Row>
        <Form.Group
          as={Col}
          md={columnSize}
          className={alignCenter ? 'mx-auto' : ''}
          controlId="validationFormik02"
        >
          <Form.Label>{translationDisabled ? 'Last name' : t('Last_name')}</Form.Label>
          <Form.Control
            type="text"
            name="lastName"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.lastName}
            maxLength={!isB2bAccount && 30}
            readOnly={!canEditLastName}
          />
          <Form.Control.Feedback type="invalid">{formik.errors.lastName}</Form.Control.Feedback>
        </Form.Group>
      </Row>
      {formik.values.email && (
        <Row>
          <Form.Group
            as={Col}
            md={columnSize}
            className={alignCenter ? 'mx-auto' : ''}
            controlId="validationFormik03"
          >
            <Form.Label>{translationDisabled ? 'Work email' : t('Work_email')}</Form.Label>
            <Form.Control type="text" name="email" value={formik.values.email} readOnly />
          </Form.Group>
        </Row>
      )}
      {isB2bAccount && (
        <Row>
          <Form.Group
            as={Col}
            md={columnSize}
            className={alignCenter ? 'mx-auto' : ''}
            controlId="validationFormik03"
          >
            <Form.Label>Account ID</Form.Label>
            <Form.Control type="text" name="email" value={formik.values.accountId} readOnly />
          </Form.Group>
        </Row>
      )}
      {formik.values.amsSuperAdminEmail &&
        formik.values.amsSuperAdminEmail !== formik.values.email && (
          <Row>
            <Form.Group
              as={Col}
              md={columnSize}
              className={alignCenter ? 'mx-auto' : ''}
              controlId="validationFormik03"
            >
              <Form.Label>
                {translationDisabled ? 'Super admin email address' : t('Super_admin_email_address')}
              </Form.Label>
              <Form.Control
                type="text"
                name="amsSuperAdminEmail"
                value={formik.values.amsSuperAdminEmail}
                readOnly
              />
            </Form.Group>
          </Row>
        )}
      {!adSSoSettings?.isLinked && !isB2bAccount && (
        <Row>
          <Form.Group
            as={Col}
            md={columnSize}
            className={classNames(
              styles.accountInformationSecureForm,
              alignCenter ? 'mx-auto' : '',
              'pt-4'
            )}
          >
            <h3>
              {translationDisabled ? 'KEEP YOUR ACCOUNT SECURE' : t('KEEP_YOUR_ACCOUNT_SECURE')}
            </h3>
            <p>
              {translationDisabled
                ? 'Protect your account by enabling two-step verification'
                : t('Protect_your_account_text')}
              .&nbsp;{!showOtherDetails && <br />}
              <Link href="https://account.samsung.com/membership/guide/2step/gate">
                <a target="_blank">{translationDisabled ? 'Learn more' : t('Learn_more')}</a>
              </Link>
            </p>
            <Link href="https://v3.account.samsung.com/dashboard/security">
              <a target="_blank" className="btn btn-outline-primary">
                {translationDisabled
                  ? 'SET UP TWO-STEP VERIFICATION'
                  : t('SET_UP_TWO-STEP_VERIFICATION')}
              </a>
            </Link>
            {!showOtherDetails && (
              <p className="mt-3">
                {translationDisabled ? 'Update your password in' : t('Update_your_password_in')}
                &nbsp;
                <Link href="https://account.samsung.com">
                  <a target="_blank">
                    {translationDisabled ? 'Samsung Account' : t('Samsung_Account')}
                  </a>
                </Link>
                .
              </p>
            )}
          </Form.Group>
        </Row>
      )}
      {isB2bAccount && (
        <>
          {!adSSoSettings?.isLinked && (
            <Row>
              <Form.Group
                as={Col}
                md={columnSize}
                className={classNames(
                  styles.accountInformationSecureForm,
                  alignCenter ? 'mx-auto' : '',
                  'pt-2'
                )}
              >
                <h3>Edit personal information</h3>
                <p>Go to Samsung Account for Business to update your personal information.</p>

                <Link
                  href={`${publicRuntimeConfig.samsungAccountBusinessBaseUrl}/business/admin/users`}
                >
                  <a
                    target="_blank"
                    className={classNames(
                      styles.updatePreferenceBtn,
                      'btn btn-outline-primary arrow-up'
                    )}
                  >
                    Edit information
                    <img src={'/images/arrow-up-right.svg'} alt="Arrow Up Right" className="icon" />
                  </a>
                </Link>
              </Form.Group>
            </Row>
          )}
        </>
      )}
      {showOtherDetails && (
        <>
          {!adSSoSettings?.isLinked && (
            <Row>
              <Form.Group
                as={Col}
                md={columnSize}
                className={classNames(
                  styles.accountInformationSecureForm,
                  alignCenter ? 'mx-auto' : '',
                  'pt-2'
                )}
              >
                <h3>Change password</h3>
                {isB2bAccount ? (
                  <p>Go to Samsung Account for Business to update your password. </p>
                ) : (
                  <p>Update your password in Samsung Account.</p>
                )}

                {isB2bAccount ? (
                  <Link
                    href={`${publicRuntimeConfig.samsungAccountBusinessBaseUrl}/myaccount/dashboard`}
                  >
                    <a
                      target="_blank"
                      className={classNames(
                        styles.updatePreferenceBtn,
                        'btn btn-outline-primary arrow-up'
                      )}
                    >
                      CHANGE PASSWORD
                      <img
                        src={'/images/arrow-up-right.svg'}
                        alt="Arrow Up Right"
                        className="icon"
                      />
                    </a>
                  </Link>
                ) : (
                  <Link href="https://account.samsung.com">
                    <a target="_blank" className="btn btn-outline-primary arrow-up">
                      CHANGE PASSWORD
                    </a>
                  </Link>
                )}
              </Form.Group>
            </Row>
          )}
          <Row>
            <Col md={columnSize} className="pt-4">
              <h3 className="mb-3">MARKETING EMAIL COMMUNICATIONS</h3>
            </Col>
          </Row>
          <Row>
            <Col md={columnSize}>
              <div className={styles.emailOptIn}>
                {isB2bAccount ? (
                  <span>
                    Choose whether you want to receive emails about Samsung Knox products, services,
                    events, and promotions.
                  </span>
                ) : (
                  <span>
                    Stay up-to-date with Samsung Knox products, services, events, and promotions.
                  </span>
                )}{' '}
                <EmailOptIn
                  show={show}
                  setShow={setShow}
                  linkText={'Learn more'}
                  linkId={'ga-kp-myaccount-emailsettings'}
                  ppId={'ga-kp-myaccount-emailsettings-samsungknoxprivacy'}
                />
              </div>
              <Link href="https://sec.business.samsung.com/KnoxPreference">
                <a
                  target="_blank"
                  className={classNames(
                    styles.updatePreferenceBtn,
                    'btn btn-outline-primary arrow-up'
                  )}
                >
                  CHANGE PREFERENCE
                  <img src={'/images/arrow-up-right.svg'} alt="Arrow Up Right" className="icon" />
                </a>
              </Link>
            </Col>
          </Row>
        </>
      )}
    </>
  )
}

export default connect(SamsungAccountDetailsFields)
